<template>
    <div class="container">
        <div class="common-header-wrap">
            <mt-header class="common-header" title="Merchant login">
                <mt-button icon="back" slot="left" @click="$router.go(-1)"></mt-button>
                <mt-button v-if="config && config.store_joinin_open!=0" slot="right" @click="goRegister">Settle in</mt-button>
            </mt-header>
        </div>
        <div class="top-wrapper">
            <div>
                <mt-field class="input-wrapper" v-model="sellername" placeholder="Merchant account" type="text" />
            </div>
            <div>
                <mt-field type="password" class="input-wrapper" v-model="password" placeholder="Please enter password" maxlength="20" />
            </div>
        </div>
        <mt-button type="primary" class="ds-button-large mt-10 mb-10" v-on:click="signin">Login</mt-button>
    </div>
</template>

<script>
import { sellerlogin } from '../../../api/sellerLogin'
import { Indicator, Toast } from 'mint-ui'
import { mapState, mapMutations, mapActions } from 'vuex'
export default {
  name: 'login',
  data () {
    return {
      sellername: '',
      password: ''
    }
  },
  created: function () {
    Indicator.close()
    if (this.$route.query.clear) {
      this.sellerLogout()
    }
    this.fetchConfig({}).then(
      response => {
      },
      error => {
        Toast(error.message)
      }
    )
  },
  computed: {
    ...mapState({
      config: state => state.config.config
    }),
  },
  methods: {
    ...mapActions({
      fetchConfig: 'fetchConfig'
    }),
    ...mapMutations({
      saveAuthInfo: 'sellerLogin',
      saveMemberAuthInfo: 'memberLogin',
      sellerLogout: 'sellerLogout'
    }),
    goRegister () {
      this.$router.push({ name: 'SellerJoinin1' })
    },
    signin () {
      let sellername = this.sellername
      let password = this.password
      if (sellername.length === 0) {
        Toast('Please enter username/email/phone number')
        return
      }
      // TODO: 用户名（为手机号或邮箱）校验
      if (password.length === 0) {
        Toast('Please enter password')
        return
      }
      if (password.length < 6) {
        Toast('Enter at least 6 digits password')
        return
      }
      Indicator.open()
      sellerlogin(sellername, password).then(
        response => {
          Indicator.close()
          this.saveAuthInfo({ token: response.result.token, info: response.result.info })
          this.saveMemberAuthInfo({ token: response.result.member_token, info: response.result.member_info })
          this.goSellerIndex()
        },
        error => {
          Indicator.close()
          Toast(error.message)
        }
      )
    },
    goSellerIndex () {
      this.$router.push({ name: 'SellerIndex' })
    }
  }
}
</script>

<style scoped lang='scss'>
    .container {
        flex: 1;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: stretch;
        background-color: #F0F2F5;
    .top-wrapper {
    .input-wrapper {
        display: flex;
        align-content: center;
        align-items: center;
        padding-left: 0.5rem;
        background-color: #fff;
        height: 2.2rem;
    img {
        width: 1.2rem;
        height: 1.2rem;
        margin: 0;
        padding: 0;
    }
    input {
        flex: 1;
        font-size:.7rem;
    }
    .bottom-input {
        border-bottom-width: 0;
    }
    }
    }
    }
</style>
